// Script de tracking pour les événements de panier
// Écoute les événements Shopify et déclenche les événements de tracking personnalisés

// Initialise l'état précédent du panier au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      window.previousCartState = cartData;
      //console.log("[Tracking Debug] État initial du panier initialisé:", cartData);
    })
    .catch(error => {
      //console.error('[Tracking Debug] Erreur lors de l\'initialisation de l\'état du panier:', error);
    });
});

// Écoute de l'événement d'ajout au panier
if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  //console.log("[Tracking Debug] Système de pub/sub disponible, écoute de l\'événement cartUpdate");
  subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {

    // Vérifie que c'est bien un ajout depuis le formulaire produit
    if (event.source === 'product-form' && event.cartData) {

      // La réponse de l'API /cart/add.js contient directement les infos du produit ajouté
      // Pas besoin de chercher dans cartData.items
      const addedItem = event.cartData;

      if (addedItem && addedItem.variant_id) {

        // Structure les données du produit ajouté (même format que Paco)
        const item_updated = {
          "id": addedItem.variant_id,
          "name": addedItem.product_title,
          "price": addedItem.price / 100, // Shopify renvoie en centimes
          "brand": "pr",
          "category": "fashion",
          "variant": addedItem.variant_title || "none",
          "position": "none",
          "quantity": addedItem.quantity,
          "dimension63": "fashion",
          "dimension67": addedItem.original_price ? (addedItem.original_price / 100) : (addedItem.price / 100),
          "dimension64": "none", // couleur si disponible
          "dimension79": "none", // discount
          "dimension66": "none", // discount percentage
          "dimension68": "none", // gender
          "dimension69": "false", // is customizable
          "dimension65": "none", // customization type
          "dimension71": "none", // launch date
          "dimension80": "none", // product line
          "dimension74": "none", // subcategory
          "dimension77": "none", // universe
          "dimension70": "false", // is suggested
          "dimension75": "none", // suggested strategy
          "dimension72": "false", // sample
          "dimension73": "none", // sample type
          "dimension76": "regular" // product type
        };

        // Récupère l'état complet du panier via l'API
        fetch('/cart.js')
          .then(response => response.json())
          .then(fullCartData => {

            // Structure les données du panier complet
            const cart_updated = fullCartData.items.map(item => ({
              "id": item.variant_id,
              "price": item.price / 100,
              "quantity": item.quantity,
              "name": item.product_title,
              "variant": item.variant_title || "none"
            }));

            // Crée l'événement personnalisé avec les données
            const eventData = {
              item_updated: item_updated,
              cart_updated: cart_updated
            };

            // Déclenche l'événement que le tracking-gtm.liquid va écouter
            document.dispatchEvent(new CustomEvent("tracking_addtocart", { detail: eventData }));

            // Met à jour l'état précédent après l'ajout pour permettre la détection des suppressions
            window.previousCartState = fullCartData;
          })
          .catch(error => {
            console.error('[Tracking Debug] Erreur lors de la récupération du panier complet:', error);
            // En cas d'erreur, on envoie quand même l'événement avec juste le produit ajouté
            const eventData = {
              item_updated: item_updated,
              cart_updated: [item_updated]
            };
            document.dispatchEvent(new CustomEvent("tracking_addtocart", { detail: eventData }));

            // Met à jour l'état précédent même en cas d'erreur
            window.previousCartState = { items: [item_updated] };
          });
      }
    }

    // Vérifie que c'est une mise à jour depuis cart-items (changement de quantité possible)
    if (event.source === 'cart-items' && event.cartData) {
      //console.log("[Tracking Debug] Mise à jour du panier détectée depuis cart-items");

      // Récupère l'état précédent du panier pour comparer
      fetch('/cart.js')
        .then(response => response.json())
        .then(currentCartData => {
          // Compare avec l'état précédent stocké dans window
          if (window.previousCartState) {
            const previousItems = window.previousCartState.items || [];
            const currentItems = currentCartData.items || [];

            // Trouve les produits supprimés (présents avant, absents maintenant)
            const removedItems = previousItems.filter(prevItem =>
              !currentItems.some(currentItem => currentItem.variant_id === prevItem.variant_id)
            );

            // Trouve les produits avec quantité réduite à 0
            const zeroQuantityItems = previousItems.filter(prevItem => {
              const currentItem = currentItems.find(currentItem => currentItem.variant_id === prevItem.variant_id);
              return currentItem && currentItem.quantity === 0;
            });

            // Trouve les produits avec quantité augmentée (ajouts)
            const addedItems = currentItems.filter(currentItem => {
              const prevItem = previousItems.find(prevItem => prevItem.variant_id === currentItem.variant_id);
              return prevItem && currentItem.quantity > prevItem.quantity;
            });

            // Trouve les produits avec quantité diminuée (suppressions partielles)
            const reducedItems = currentItems.filter(currentItem => {
              const prevItem = previousItems.find(prevItem => prevItem.variant_id === currentItem.variant_id);
              return prevItem && currentItem.quantity < prevItem.quantity && currentItem.quantity > 0;
            });

            // Combine les suppressions complètes
            const allRemovedItems = [...removedItems, ...zeroQuantityItems];

            if (allRemovedItems.length > 0) {
              //console.log("[Tracking Debug] Produits supprimés détectés:", allRemovedItems);

              // Pour chaque produit supprimé, déclenche l'événement de tracking
              allRemovedItems.forEach(removedItem => {
                const item_updated = {
                  "id": removedItem.variant_id,
                  "name": removedItem.product_title,
                  "price": removedItem.price / 100,
                  "brand": "pr",
                  "category": "fashion",
                  "variant": removedItem.variant_title || "none",
                  "position": "none",
                  "quantity": removedItem.quantity,
                  "dimension63": "fashion",
                  "dimension67": removedItem.original_price ? (removedItem.original_price / 100) : (removedItem.price / 100),
                  "dimension64": "none",
                  "dimension79": "none",
                  "dimension66": "none",
                  "dimension68": "none",
                  "dimension69": "false",
                  "dimension65": "none",
                  "dimension71": "none",
                  "dimension80": "none",
                  "dimension74": "none",
                  "dimension77": "none",
                  "dimension70": "false",
                  "dimension75": "none",
                  "dimension72": "false",
                  "dimension73": "none",
                  "dimension76": "regular"
                };

                // Structure les données du panier actuel
                const cart_updated = currentItems.map(item => ({
                  "id": item.variant_id,
                  "price": item.price / 100,
                  "quantity": item.quantity,
                  "name": item.product_title,
                  "variant": item.variant_title || "none"
                }));

                const eventData = {
                  item_updated: item_updated,
                  cart_updated: cart_updated
                };

                // Déclenche l'événement de suppression
                document.dispatchEvent(new CustomEvent("tracking_removefromcart", { detail: eventData }));
              });
            }

            // Traite les ajouts de quantité
            if (addedItems.length > 0) {
              //console.log("[Tracking Debug] Produits avec quantité augmentée détectés:", addedItems);

              addedItems.forEach(addedItem => {
                const prevItem = previousItems.find(prevItem => prevItem.variant_id === addedItem.variant_id);
                const quantityAdded = addedItem.quantity - (prevItem ? prevItem.quantity : 0);

                if (quantityAdded > 0) {
                  const item_updated = {
                    "id": addedItem.variant_id,
                    "name": addedItem.product_title,
                    "price": addedItem.price / 100,
                    "brand": "pr",
                    "category": "fashion",
                    "variant": addedItem.variant_title || "none",
                    "position": "none",
                    "quantity": quantityAdded,
                    "dimension63": "fashion",
                    "dimension67": addedItem.original_price ? (addedItem.original_price / 100) : (addedItem.price / 100),
                    "dimension64": "none",
                    "dimension79": "none",
                    "dimension66": "none",
                    "dimension68": "none",
                    "dimension69": "false",
                    "dimension65": "none",
                    "dimension71": "none",
                    "dimension80": "none",
                    "dimension74": "none",
                    "dimension77": "none",
                    "dimension70": "false",
                    "dimension75": "none",
                    "dimension72": "false",
                    "dimension73": "none",
                    "dimension76": "regular"
                  };

                  // Structure les données du panier actuel
                  const cart_updated = currentItems.map(item => ({
                    "id": item.variant_id,
                    "price": item.price / 100,
                    "quantity": item.quantity,
                    "name": item.product_title,
                    "variant": item.variant_title || "none"
                  }));

                  const eventData = {
                    item_updated: item_updated,
                    cart_updated: cart_updated
                  };

                  // Déclenche l'événement d'ajout
                  document.dispatchEvent(new CustomEvent("tracking_addtocart", { detail: eventData }));
                }
              });
            }

            // Traite les réductions de quantité
            if (reducedItems.length > 0) {
              //console.log("[Tracking Debug] Produits avec quantité réduite détectés:", reducedItems);

              reducedItems.forEach(reducedItem => {
                const prevItem = previousItems.find(prevItem => prevItem.variant_id === reducedItem.variant_id);
                const quantityRemoved = (prevItem ? prevItem.quantity : 0) - reducedItem.quantity;

                if (quantityRemoved > 0) {
                  const item_updated = {
                    "id": reducedItem.variant_id,
                    "name": reducedItem.product_title,
                    "price": reducedItem.price / 100,
                    "brand": "pr",
                    "category": "fashion",
                    "variant": reducedItem.variant_title || "none",
                    "position": "none",
                    "quantity": quantityRemoved,
                    "dimension63": "fashion",
                    "dimension67": reducedItem.original_price ? (reducedItem.original_price / 100) : (reducedItem.price / 100),
                    "dimension64": "none",
                    "dimension79": "none",
                    "dimension66": "none",
                    "dimension68": "none",
                    "dimension69": "false",
                    "dimension65": "none",
                    "dimension71": "none",
                    "dimension80": "none",
                    "dimension74": "none",
                    "dimension77": "none",
                    "dimension70": "false",
                    "dimension75": "none",
                    "dimension72": "false",
                    "dimension73": "none",
                    "dimension76": "regular"
                  };

                  // Structure les données du panier actuel
                  const cart_updated = currentItems.map(item => ({
                    "id": item.variant_id,
                    "price": item.price / 100,
                    "quantity": item.quantity,
                    "name": item.product_title,
                    "variant": item.variant_title || "none"
                  }));

                  const eventData = {
                    item_updated: item_updated,
                    cart_updated: cart_updated
                  };

                  // Déclenche l'événement de suppression
                  document.dispatchEvent(new CustomEvent("tracking_removefromcart", { detail: eventData }));
                }
              });
            }
          }

          // Met à jour l'état précédent pour la prochaine comparaison
          window.previousCartState = currentCartData;
        })
        .catch(error => {
          //console.error('[Tracking Debug] Erreur lors de la récupération du panier pour tracking suppression:', error);
        });
    }
  });
}

// Fallback si le système de pub/sub n'est pas disponible
// Écoute directement les réponses fetch vers /cart/add.js
if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
  console.warn('Système de pub/sub non disponible, utilisation du fallback pour le tracking panier');

  // Intercepte les requêtes fetch vers l'API cart
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];

    if (typeof url === 'string' && url.includes('/cart/add')) {
      return originalFetch.apply(this, args)
        .then(response => {
          if (response.ok) {
            response.clone().json().then(addedItemData => {
              // La réponse de /cart/add.js contient directement les infos du produit ajouté
              if (addedItemData && addedItemData.variant_id) {
                  const item_updated = {
                    "id": addedItemData.variant_id,
                    "name": addedItemData.product_title,
                    "price": addedItemData.price / 100,
                    "brand": "pr",
                    "category": "fashion",
                    "variant": addedItemData.variant_title || "none",
                    "position": "none",
                    "quantity": addedItemData.quantity,
                    "dimension63": "fashion",
                    "dimension67": addedItemData.original_price ? (addedItemData.original_price / 100) : (addedItemData.price / 100),
                    "dimension64": "none",
                    "dimension79": "none",
                    "dimension66": "none",
                    "dimension68": "none",
                    "dimension69": "false",
                    "dimension65": "none",
                    "dimension71": "none",
                    "dimension80": "none",
                    "dimension74": "none",
                    "dimension77": "none",
                    "dimension70": "false",
                    "dimension75": "none",
                    "dimension72": "false",
                    "dimension73": "none",
                    "dimension76": "regular"
                  };

                  // Récupère l'état complet du panier via l'API
                  fetch('/cart.js')
                    .then(response => response.json())
                    .then(fullCartData => {
                      const cart_updated = fullCartData.items.map(item => ({
                        "id": item.variant_id,
                        "price": item.price / 100,
                        "quantity": item.quantity,
                        "name": item.product_title,
                        "variant": item.variant_title || "none"
                      }));

                      const eventData = {
                        item_updated: item_updated,
                        cart_updated: cart_updated
                      };

                      document.dispatchEvent(new CustomEvent("tracking_addtocart", { detail: eventData }));

                      // Met à jour l'état précédent après l'ajout pour permettre la détection des suppressions
                      window.previousCartState = fullCartData;
                    })
                    .catch(error => {
                      // En cas d'erreur, on envoie quand même l'événement
                      const eventData = {
                        item_updated: item_updated,
                        cart_updated: [item_updated]
                      };
                      document.dispatchEvent(new CustomEvent("tracking_addtocart", { detail: eventData }));

                      // Met à jour l'état précédent même en cas d'erreur
                      window.previousCartState = { items: [item_updated] };
                    });
                }
            });
          }
          return response;
        });
    }

    return originalFetch.apply(this, args);
  };
}